export default class DiagnosticLinkEventTypeDto {
    constructor(obj) {
        this.codeDiagnostic = obj.codeDiagnostic
        this.eventType = obj.eventType
    }
}
